<!-- src/app/forgot-password/forgot-right/forgot-right.component.html -->
<div class="card">
  <div class="logo">
    <app-botmaa></app-botmaa>
  </div>

  <div class="steps">
    <div class="step" [class.completed]="((stage$ | async)?.stage ?? 0) >= 2">
      <div class="num">1</div>
      <div class="body">
        <div class="title">Reset your password</div>
        <div class="desc">We will send you a 4-digit passcode</div>
      </div>
      @if(((stage$ | async)?.stage ?? 0) > 1){<div class="tick">✓</div>}
    </div>

    <div class="step" [class.completed]="((stage$ | async)?.stage ?? 0) >= 3">
      <div class="num">2</div>
      <div class="body">
        <div class="title">Enter confirmation code</div>
        <div class="desc">We sent you code to your Email.</div>
      </div>
      @if(((stage$ | async)?.stage ?? 0) > 2){<div class="tick">✓</div>}
    </div>

    <div class="step" [class.completed]="((stage$ | async)?.stage ?? 0) >= 4">
      <div class="num">3</div>
      <div class="body">
        <div class="title">Create a new password</div>
        <div class="desc">Must be at least 8 characters</div>
      </div>
      @if(((stage$ | async)?.stage ?? 0) > 3){<div class="tick">✓</div>}
    </div>

    <div class="step" [class.completed]="((stage$ | async)?.stage ?? 0) >= 4">
      <div class="num">4</div>
      <div class="body">
        <div class="title">Password reset !</div>
        <div class="desc">Success. Click to log in</div>
      </div>
      @if(((stage$ | async)?.stage ?? 0) === 4){<div class="tick">✓</div>}
    </div>
  </div>
</div>
